module.exports = __webpack_public_path__ + "static/podlove-9a81f675bde3e668581701f2911135ad.png";